import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Tbl, DT, n } from "./SkuParts";

export default function WarehousesTab({ d, onPutaway }) {
  const [open, setOpen] = useState(null);
  const s = d.stock;
  const bins = (d.bins || []).filter((b) => !open || (b.warehouse || "Unassigned") === open);
  const reservedBy = {};
  (d.reservations || []).forEach((r) => { if (r.bin) reservedBy[r.bin] = (reservedBy[r.bin] || 0) + (r.quantity || 0); });
  return (
    <div className="space-y-4" data-testid="sku-tab-warehouses">
      {s.unlocated > 0 && (
        <div className="bg-signal-amber/10 border border-signal-amber/50 rounded-lg p-4 flex flex-wrap items-center gap-4" data-testid="sku-unlocated-block">
          <div>
            <p className="text-[10px] font-mono uppercase tracking-widest text-signal-amber">Stock without location</p>
            <p className="metric text-2xl font-extrabold">{n(s.unlocated)} <span className="text-sm font-normal">PCS</span></p>
            <p className="text-xs text-muted-foreground font-mono uppercase">Staging · Putaway pending · Location: NOT ASSIGNED</p>
            <p className="text-xs text-muted-foreground mt-1">Not counted as available until putaway is completed.</p>
          </div>
          {onPutaway && <Button className="ml-auto bg-signal-amber text-black font-bold hover:bg-signal-amber/90" onClick={onPutaway} data-testid="sku-complete-putaway-btn">COMPLETE PUTAWAY</Button>}
        </div>
      )}
      <p className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">Warehouses / Godowns / Factories holding this SKU — click a row to drill down</p>
      <Tbl testid="sku-warehouses-table" empty="This SKU is not located in any warehouse / factory" head={["Location Name", "Type", "Address", "Physical", "Available", "Reserved", "QC Hold", "Unlocated", "Bins", "Last Movement"]}>
        {(d.warehouses || []).map((w) => (
          <tr key={w.warehouse} onClick={() => setOpen(open === w.warehouse ? null : w.warehouse)} className={`border-b border-border/50 cursor-pointer hover:bg-accent/40 ${open === w.warehouse ? "bg-primary/10" : ""}`} data-testid={`sku-wh-${w.warehouse}`}>
            <td className="px-3 py-2 font-semibold">{w.warehouse}</td>
            <td className="px-3 py-2 text-xs capitalize">{w.type}</td>
            <td className="px-3 py-2 text-xs">{w.address || "—"}</td>
            <td className="px-3 py-2 metric font-bold">{n(w.physical)}</td>
            <td className="px-3 py-2 metric text-signal-green">{n(w.available)}</td>
            <td className="px-3 py-2 metric text-signal-amber">{n(w.reserved)}</td>
            <td className="px-3 py-2 metric">—</td>
            <td className="px-3 py-2 metric">—</td>
            <td className="px-3 py-2 metric">{w.bins}</td>
            <td className="px-3 py-2"><DT v={w.last_movement} /></td>
          </tr>
        ))}
      </Tbl>
      <p className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">Location drill-down {open ? `· ${open}` : "· all"} — Warehouse → Zone → Aisle → Rack → Level / Shelf → Bin</p>
      <Tbl testid="sku-bins-table" empty={s.unlocated > 0 ? `No bins yet — ${n(s.unlocated)} pcs awaiting putaway` : "No stock in any bin"} head={["Warehouse", "Zone", "Aisle", "Rack", "Level", "Shelf", "Bin", "Batch", "Quantity", "Reserved", "Available", "Putaway Status", "Last Putaway"]}>
        {bins.map((b) => (
          <tr key={b.bin} className="border-b border-border/50" data-testid={`sku-bin-${b.bin}`}>
            <td className="px-3 py-2 text-xs">{b.warehouse}</td>
            <td className="px-3 py-2 text-xs">{b.zone || "—"}</td>
            <td className="px-3 py-2 text-xs">{b.aisle || "—"}</td>
            <td className="px-3 py-2 text-xs">{b.rack || "—"}</td>
            <td className="px-3 py-2 text-xs">{b.level || "—"}</td>
            <td className="px-3 py-2 text-xs">{b.shelf || "—"}</td>
            <td className="px-3 py-2 font-mono text-xs font-bold">{b.bin}</td>
            <td className="px-3 py-2 text-xs">{b.batch || "—"}</td>
            <td className="px-3 py-2 metric font-bold">{n(b.quantity)}</td>
            <td className="px-3 py-2 metric text-signal-amber">{n(reservedBy[b.bin])}</td>
            <td className="px-3 py-2 metric text-signal-green">{n(b.quantity - (reservedBy[b.bin] || 0))}</td>
            <td className="px-3 py-2 text-[10px] font-mono uppercase text-signal-green">{b.mismatch ? "MISMATCH" : "LOCATED"}</td>
            <td className="px-3 py-2"><DT v={b.putaway_at} /></td>
          </tr>
        ))}
      </Tbl>
    </div>
  );
}
